/**
 * 表单校验规则
 */
import RuleUtil from './rule'

const myRules = {
  /**
   * 验证
   * @param {*} rule
   * @param {*} value
   * @param {*} callback
   * @param {*} type
   * @returns
   */
  validate: (rule, value, callback, type) => {
    if (value) {
      const msg = RuleUtil.validate(value, type)
      if (msg) {
        callback(new Error(msg))
        return
      }
    }
    callback()
  },
  /**
   * 必填
   * @param rule
   * @param value
   * @param callback
   */
  required: (rule, value, callback) => {
    const msg = RuleUtil.required(value)
    if (msg) {
      callback(new Error(msg))
      return
    }
    callback()
  },
  /**
   * 机构名称
   * @param rule
   * @param value
   * @param callback
   */
  orgName: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'orgName')
  },
  /**
   * idCard
   * @param rule
   * @param value
   * @param callback
   */
  idCard: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'idCard')
  },
  /**
   * 手机号码
   * @param rule
   * @param value
   * @param callback
   */
  mobile: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'mobile')
  },
  /**
   * 电话号码 (手机号 + 固定电话)
   * @param rule
   * @param value
   * @param callback
   */
  phone: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'phone')
  },
  /**
   * 邮箱
   * @param rule
   * @param value
   * @param callback
   */
  email: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'email')
  },
  /**
   * qq
   * @param rule
   * @param value
   * @param callback
   */
  qq: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'qq')
  },
  /**
   * 邮政编码
   * @param rule
   * @param value
   * @param callback
   */
  postCode: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'postCode')
  },
  /**
   * 正整数
   * @param rule
   * @param value
   * @param callback
   */
  positiveInteger: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'positiveInteger')
  },
  /**
   * 负整数
   * @param rule
   * @param value
   * @param callback
   */
  negativeInteger: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'negativeInteger')
  },
  /**
   * 正浮点数
   * @param rule
   * @param value
   * @param callback
   */
  positiveFloat: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'positiveFloat')
  },
  /**
   * 负浮点数
   * @param rule
   * @param value
   * @param callback
   */
  negativeFloat: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'negativeFloat')
  },
  /**
   * ip
   * @param rule
   * @param value
   * @param callback
   */
  ip: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'ip')
  },
  /**
   * url
   * @param rule
   * @param value
   * @param callback
   */
  url: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'url')
  },
  /**
   * 字母
   * @param rule
   * @param value
   * @param callback
   */
  letter: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'letter')
  },
  /**
   * 数字
   * @param rule
   * @param value
   * @param callback
   */
  number: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'number')
  },
  /**
   * 字母数字
   * @param rule
   * @param value
   * @param callback
   */
  letterNumber: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'letterNumber')
  },
  /**
   * 中文
   * @param rule
   * @param value
   * @param callback
   */
  chinese: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'chinese')
  },
  /**
   * 2位数价格
   * @param rule
   * @param value
   * @param callback
   */
  price2: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'price2')
  },
  /**
   * 4位数价格
   * @param rule
   * @param value
   * @param callback
   */
  price4: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'price4')
  },
  /**
   * 变量名
   * @param rule
   * @param value
   * @param callback
   */
  varName: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'varName')
  },
  /**
   * 用户名
   * @param rule
   * @param value
   * @param callback
   */
  userName: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'userName')
  },
  /**
   * 密码
   * @param rule
   * @param value
   * @param callback
   */
  pwd: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'pwd')
  },
  /**
   * md5
   * @param rule
   * @param value
   * @param callback
   */
  md5: (rule, value, callback) => {
    myRules.validate(rule, value, callback, 'md5')
  }
}

export default myRules
